import { useEffect, useState } from 'react'

export function useBreakpoint() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  )

  useEffect(() => {
    const obs = new ResizeObserver(() => setIsMobile(window.innerWidth < 768))
    obs.observe(document.documentElement)
    return () => obs.disconnect()
  }, [])

  return { isMobile }
}
